var _rect, _rect2, _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuantumEncryption(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "url(#paint0_linear_18_2531)",
    strokeOpacity: 0.41
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14307 30.0001C5.14307 16.2719 16.272 5.14294 30.0002 5.14294C43.7284 5.14294 54.8573 16.2719 54.8573 30.0001C54.8573 43.7283 43.7284 54.8572 30.0002 54.8572C16.272 54.8572 5.14307 43.7283 5.14307 30.0001Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0005 5.64294C43.4524 5.6431 54.3569 16.5484 54.3569 30.0004C54.3568 43.4522 43.4523 54.3567 30.0005 54.3568C16.5485 54.3568 5.64322 43.4523 5.64307 30.0004C5.64307 16.5483 16.5484 5.64294 30.0005 5.64294Z",
    stroke: "url(#paint1_linear_18_2531)",
    strokeOpacity: 0.41
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2531)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2531",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 30,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15H15V45H45V15Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 24.6875C27.6375 24.6875 27.1875 25.675 27.1875 27.5V28.275H32.8125V27.5C32.8125 25.675 32.3625 24.6875 30 24.6875Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 33.525C30.7594 33.525 31.375 32.9094 31.375 32.15C31.375 31.3906 30.7594 30.775 30 30.775C29.2406 30.775 28.625 31.3906 28.625 32.15C28.625 32.9094 29.2406 33.525 30 33.525Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 17.5C23.1 17.5 17.5 23.1 17.5 30C17.5 36.9 23.1 42.5 30 42.5C36.9 42.5 42.5 36.9 42.5 30C42.5 23.1 36.9 17.5 30 17.5ZM36.725 33.125C36.725 35.875 35.875 36.725 33.125 36.725H26.875C24.125 36.725 23.275 35.875 23.275 33.125V31.875C23.275 29.7375 23.7875 28.75 25.3125 28.4125V27.5C25.3125 26.3375 25.3125 22.8125 30 22.8125C34.6875 22.8125 34.6875 26.3375 34.6875 27.5V28.4125C36.2125 28.75 36.725 29.7375 36.725 31.875V33.125Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2531",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2531",
    x1: 30.0002,
    y1: 5.14294,
    x2: 30.0002,
    y2: 54.8572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuantumEncryption);
export default __webpack_public_path__ + "static/media/icon-quantum-encryption.3317926cc610685463835ef655fef30f.svg";
export { ForwardRef as ReactComponent };